import { getUserInfo } from './facility'
import sideBarItems from '@/FackApi/json/SideBar.json'

// Super admin accounts have no facility; provider (business) accounts do.
export const isAdminAccount = (userInfo = getUserInfo()) => !userInfo?.facility_id && !userInfo?.facility?.facility_type

export const getPermissionNames = (userInfo = getUserInfo()) =>
  (userInfo?.permissions || []).map(permission => (typeof permission === 'string' ? permission : permission?.name))

// The backend dropped `<group>_show`; viewing a record is covered by `<group>_list`.
const normalize = (name) => name.replace(/_show$/, '_list')

// `permission` may be a name or an array of names (any of them grants access).
// No permission means the screen or action is not restricted. Both super admin
// and facility accounts are checked against the permissions of their role.
export const hasPermission = (permission, userInfo = getUserInfo()) => {
  if (!permission || (Array.isArray(permission) && !permission.length)) return true
  const granted = getPermissionNames(userInfo)
  const required = Array.isArray(permission) ? permission : [permission]
  return required.some(name => granted.includes(normalize(name)))
}

const matchesServiceType = (serviceTypes, userInfo) =>
  !serviceTypes || serviceTypes === 'all' ||
  userInfo?.facility?.facility_type?.toLowerCase() === String(serviceTypes).toLowerCase()

// First page (in sidebar order) the current account can open.
export const firstAllowedRoute = (userInfo = getUserInfo()) => {
  const userType = isAdminAccount(userInfo) ? 'admin' : 'provider'
  return sideBarItems.find(item =>
    item.userType === userType &&
    (userType === 'admin' || (matchesServiceType(item.serviceTypes, userInfo) && (!item.requiredAdmin || userInfo?.facility?.branches_access))) &&
    hasPermission(item.permission, userInfo)
  )?.link?.name
}

// Kept for the super admin login redirect.
export const firstAllowedAdminRoute = firstAllowedRoute
